// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function make(parkingInfoEnabled, parkingSpaces, parkingDetails) {
  let parkingSpots = parkingInfoEnabled ? Stdlib_Option.map(parkingSpaces, parkingSpaces => parkingSpaces.toString()) : undefined;
  let parkingDetails$1;
  if (parkingInfoEnabled) {
    let parkingDetails$2 = Stdlib_Option.map(parkingDetails, prim => prim.trim());
    parkingDetails$1 = parkingDetails$2 !== undefined && parkingDetails$2 !== "" ? JsxRuntime.jsx("span", {
        children: parkingDetails$2,
        className: "whitespace-pre-line"
      }) : undefined;
  } else {
    parkingDetails$1 = undefined;
  }
  return {
    parkingSpots: parkingSpots,
    parkingDetails: parkingDetails$1
  };
}

let ListingDetails = {
  make: make
};

exports.ListingDetails = ListingDetails;
/* react/jsx-runtime Not a pure module */
